/* Shared bristle guidance and live variant resolution for the finder and configurator. */
(function () {
  'use strict';
  if (window.OptileanBristles) return;
  var language = document.documentElement.lang.toLowerCase().indexOf('de') === 0 ? 'de' : 'en';
  var texts = {
    de: {
      title: 'Welcher Besatz passt?', loading: 'Besatz wird geladen …',
      intro: 'Wähle den Besatz für dieses Gerät. Die Auswahl wird mit deinem Entwurf gespeichert.',
      close: 'Abbrechen', change: 'Besatz ändern', selected: 'Besatz', choose: 'Auswählen',
      error: 'Die Besatzauswahl konnte nicht geladen werden. Bitte versuche es erneut.', retry: 'Erneut versuchen',
      absent: 'Für dieses Gerät nicht im Sortiment', unavailable: 'Aktuell nicht bestellbar',
      flaggedHint: 'Für kritische Hygienebereiche nicht geeignet.', color: 'Farbe', size: 'Besenbreite',
      choices: {
        soft: ['Weich', 'Für feinen, losen Schmutz auf glatten Flächen.', 'weich'],
        medium: ['Mittel', 'Für den Alltag: Krümel und gemischten, losen Schmutz.', 'mittel'],
        hard: ['Hart', 'Für groben, schweren Schmutz und robuste, raue Flächen.', 'hart'],
        flagged: ['Gesplisst / geschlitzt', 'Feine Borstenspitzen für Staub und Pulver in trockenen Bereichen.', 'geschlitzt']
      }
    },
    en: {
      title: 'Which bristles suit your task?', loading: 'Loading bristles …',
      intro: 'Choose the bristles for this tool. Your choice is saved with your design.',
      close: 'Cancel', change: 'Change bristles', selected: 'Bristles', choose: 'Select',
      error: 'The bristle options could not be loaded. Please try again.', retry: 'Try again',
      absent: 'Not offered for this tool', unavailable: 'Currently unavailable',
      flaggedHint: 'Not suitable for critical hygiene areas.', color: 'Colour', size: 'Broom width',
      choices: {
        soft: ['Soft', 'For fine, loose dirt on smooth surfaces.', 'weich'],
        medium: ['Medium', 'For everyday use: crumbs and mixed, loose dirt.', 'mittel'],
        hard: ['Hard', 'For coarse, heavy dirt on robust, rough surfaces.', 'hart'],
        flagged: ['Flagged / split tips', 'Fine bristle tips for dust and powders in dry areas.', 'geschlitzt']
      }
    }
  };
  var copy = texts[language], keys = ['soft', 'medium', 'hard', 'flagged'];
  var lipsCopy = Object.assign({}, copy, language === 'de' ? {
    title: 'Welche Ausführung passt?', intro: 'Wähle eine oder zwei Lippen. Die Auswahl wird mit deinem Entwurf gespeichert.',
    selected: 'Ausführung', change: 'Ausführung ändern', size: 'Arbeitsbreite', productTitle: 'Wasserschieber · 1 oder 2 Lippen',
    choices: {
      single: ['1 Lippe', 'Einlippige Ausführung mit Wechselprofil.', '1 Lippe'],
      double: ['2 Lippen', 'Zweilippige Ausführung mit zwei Abziehkanten.', '2 Lippen']
    }
  } : {
    title: 'Which blade configuration suits your task?', intro: 'Choose one or two blades. Your choice is saved with your design.',
    selected: 'Blade configuration', change: 'Change blades', size: 'Working width', productTitle: 'Squeegee · 1 or 2 blades',
    choices: {
      single: ['1 blade', 'Single-blade squeegee with replaceable profile.', '1 Lippe'],
      double: ['2 blades', 'Double-blade squeegee with two wiping edges.', '2 Lippen']
    }
  });
  function copyForHandle(handle) { return handle === 'abzeiher-400mm-einlippig-haccp' ? lipsCopy : copy; }
  function copyFor(tool) { var spec = family(tool); return spec && spec.kind === 'squeegee' ? lipsCopy : copy; }
  function defaultKey(tool) { var spec = family(tool); return spec && spec.kind === 'squeegee' ? 'single' : 'soft'; }
  function properties(key) { var result = {}; result[lipsCopy.choices[key] ? 'Ausführung' : 'Besatz'] = label(key); return result; }
  var productRequests = {};
  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/ß/g, 'ss').trim();
  }
  function colorKey(value) {
    var colors = { white: 'weiss', black: 'schwarz', blue: 'blau', red: 'rot', green: 'grun', yellow: 'gelb', purple: 'lila' };
    var key = normalize(value);
    return colors[key] || key;
  }
  function family(tool) {
    var name = normalize(tool && tool.name);
    if (/^besen\s*400\s*(mm)?$/.test(name)) return { handle: 'besen-haccp', size: '410 mm' };
    if (/^besen\s*600\s*(mm)?$/.test(name)) return { handle: 'besen-haccp', size: '625 mm' };
    if (name === 'handfeger') return { handle: 'handfeger-haccp', size: '' };
    var squeegee = name.match(/^abzieher\s*(400|600)\s*(mm)?$/);
    if (squeegee) return { handle: 'abzeiher-400mm-einlippig-haccp', size: squeegee[1] === '400' ? '420 mm' : '620 mm', kind: 'squeegee' };
    return null;
  }
  function productUrl(handle) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root + 'products/' + encodeURIComponent(handle);
  }
  function loadProduct(handle) {
    if (!productRequests[handle]) {
      productRequests[handle] = fetch(productUrl(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(function (product) { if (!Array.isArray(product.variants) || !product.variants.length) throw new Error('No variants'); return product; })
        .catch(function (error) { delete productRequests[handle]; throw error; });
    }
    return productRequests[handle];
  }
  function variantFor(product, context, key) {
    var choice = (context.kind === 'squeegee' ? lipsCopy.choices : copy.choices)[key];
    if (!choice) return null;
    return product.variants.find(function (variant) {
      // Use complete option values: "weiß / blau" must never match plain white or blue.
      if (colorKey(variant.option1) !== colorKey(context.color)) return false;
      if (context.size && normalize(variant.option2) !== normalize(context.size)) return false;
      var value = context.size ? variant.option3 : variant.option2;
      return normalize(value) === normalize(choice[2]);
    }) || null;
  }
  function label(key) { var choice = copy.choices[key] || lipsCopy.choices[key]; return choice ? choice[0] : ''; }
  function element(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text) el.textContent = text;
    return el;
  }
  function symbol(key) {
    var paths = {
      single: 'M4 16h24',
      double: 'M4 16h24M4 22h24',
      soft: 'M8 13c0 5-2 8-3 11m8-11c0 5-1 8-1 11m6-11c0 5 1 8 1 11m4-11c0 5 2 8 3 11',
      medium: 'M8 13 6 24m7-11-1 11m6-11 1 11m4-11 3 11',
      hard: 'M7 13v11m6-11v11m6-11v11m6-11v11',
      flagged: 'M8 13v7m5-7v7m6-7v7m6-7v7M8 20l-3 4m3-4 2 4m3-4-2 4m2-4 3 4m3-4-2 4m2-4 3 4m3-4-2 4m2-4 3 4'
    };
    var span = element('span', 'ol-bristle__symbol');
    span.innerHTML = '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><rect x="4" y="7" width="24" height="6" rx="2"/><path d="' + paths[key] + '"/></svg>';
    return span;
  }
  function renderChoices(host, product, context, selectedKey, onChoose) {
    var copy = context.kind === 'squeegee' ? lipsCopy : texts[language];
    var keys = context.kind === 'squeegee' ? ['single', 'double'] : ['soft', 'medium', 'hard', 'flagged'];
    host.replaceChildren();
    host.classList.add('ol-bristle');
    var grid = element('div', 'ol-bristle__choices');
    grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', copy.title);
    keys.forEach(function (key) {
      var variant = variantFor(product, context, key);
      var button = element('button', 'ol-bristle__choice');
      button.type = 'button'; button.dataset.bristle = key;
      button.setAttribute('aria-pressed', String(selectedKey === key));
      button.disabled = !variant || variant.available === false;
      var content = element('span', 'ol-bristle__choice-copy');
      content.append(element('strong', '', copy.choices[key][0]), element('span', '', copy.choices[key][1]));
      if (key === 'flagged') content.append(element('small', 'ol-bristle__flagged-hint', copy.flaggedHint));
      if (button.disabled) content.append(element('small', '', variant ? copy.unavailable : copy.absent));
      button.append(symbol(key), content);
      button.addEventListener('click', function () {
        grid.querySelectorAll('button').forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        onChoose(key, variant);
      });
      grid.append(button);
    });
    host.append(grid);
  }
  function pick(tool, selectedKey) {
    var spec = family(tool);
    var copy = copyFor(tool);
    if (!spec) return Promise.resolve(null);
    if (document.querySelector('.ol-bristle-dialog')) return Promise.resolve(null);
    return new Promise(function (resolve) {
      var previousFocus = document.activeElement;
      var dialog = element('dialog', 'ol-bristle-dialog');
      dialog.setAttribute('aria-labelledby', 'ol-bristle-dialog-title');
      var heading = element('h2', '', copy.title); heading.id = 'ol-bristle-dialog-title';
      var name = element('p', 'ol-bristle-dialog__tool', tool.name + ' · ' + (tool.boardColor ? (language === 'de' ? {white:'Weiß',black:'Schwarz',blue:'Blau',red:'Rot',green:'Grün',yellow:'Gelb'}[tool.boardColor] || tool.boardColor : tool.boardColor) : ''));
      var host = element('div', '', copy.loading); host.setAttribute('aria-live', 'polite');
      var cancel = element('button', 'ol-bristle-dialog__cancel', copy.close); cancel.type = 'button';
      dialog.append(heading, name, host, cancel);
      var choice = null;
      function finish() { if (dialog.open) dialog.close(); }
      cancel.addEventListener('click', finish);
      dialog.addEventListener('click', function (event) { if (event.target === dialog && (event.clientX < dialog.getBoundingClientRect().left || event.clientX > dialog.getBoundingClientRect().right || event.clientY < dialog.getBoundingClientRect().top || event.clientY > dialog.getBoundingClientRect().bottom)) finish(); });
      dialog.addEventListener('close', function () { dialog.remove(); if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true }); resolve(choice); }, { once: true });
      dialog.addEventListener('keydown', function (event) { event.stopPropagation(); });
      document.body.append(dialog); dialog.showModal();
      function load() {
        host.replaceChildren(element('p', '', copy.loading));
        loadProduct(spec.handle).then(function (product) {
          if (!dialog.open) return;
          renderChoices(host, product, { color: tool.boardColor, size: spec.size, kind: spec.kind }, selectedKey, function (key) { choice = key; finish(); });
        }).catch(function () {
          if (!dialog.open) return;
          var retry = element('button', 'ol-bristle-dialog__cancel', copy.retry); retry.type = 'button'; retry.addEventListener('click', load);
          host.replaceChildren(element('p', '', copy.error), retry);
        });
      }
      load();
    });
  }
  // The finder uses the same choices and resolver; a deep link opens the exact chosen Shopify variant.
  function mountFinder(host, product, handle, onChoose) {
    var isSqueegee = handle === 'abzeiher-400mm-einlippig-haccp';
    var copy = isSqueegee ? lipsCopy : texts[language];
    var context = { color: product.variants[0].option1, size: handle === 'besen-haccp' || isSqueegee ? product.variants[0].option2 : '', kind: isSqueegee ? 'squeegee' : '' };
    var heading = element('h4', 'ol-bristle__heading', copy.title);
    var selectors = element('div', 'ol-bristle__selectors');
    var choices = element('div');
    var selection = element('p', 'ol-bristle__selection'); selection.setAttribute('aria-live', 'polite');
    function render() { selection.textContent = ''; onChoose(null); renderChoices(choices, product, context, '', function (key, variant) { selection.textContent = copy.selected + ': ' + label(key) + ' · ' + variant.title; onChoose(variant); }); }
    function selectOption(name, values, field) {
      var wrap = element('label', '', name), select = element('select');
      values.forEach(function (value) { var option = element('option', '', value); option.value = value; select.append(option); });
      select.value = context[field]; select.addEventListener('change', function () { context[field] = select.value; render(); });
      wrap.append(select); selectors.append(wrap);
    }
    selectOption(copy.color, product.options[0].values, 'color');
    if (context.size) selectOption(copy.size, product.options[1].values, 'size');
    host.className = 'ol-bristle ol-bristle--finder'; host.append(heading, selectors, choices, selection); render();
  }
  window.OptileanBristles = { family: family, loadProduct: loadProduct, variantFor: variantFor, label: label, pick: pick, mountFinder: mountFinder, copy: copy, copyFor: copyFor, copyForHandle: copyForHandle, defaultKey: defaultKey, properties: properties, productUrl: productUrl };
})();
